module.exports = __webpack_public_path__ + "static/media/AMC-background.1a396341.jpg";